import i18n from '@/i18n';
/* eslint-disable */
export function requiredProperty(property) {
    return i18n.tc('validations.required.field', name, { name: property });
}
export function sameAsProperty(property, reference) {
    return i18n.tc('validations.same_as', name, reference, { name: property, reference });
}
export function requiredSelection(property) {
    return i18n.tc('validations.required.selection', name, { name: property });
}
export function uniqueProperty(property) {
    return i18n.tc('validations.unique', name, { name: property });
}
export function containsNumber(property) {
    return i18n.tc('validations.contains_number', name, { name: property });
}
export function successfulCreate(property) {
    return i18n.tc('graphql.mutation.success.create', name, { name: property });
}
export function successfulUpdate(property) {
    return i18n.tc('graphql.mutation.success.update', name, { name: property });
}
export function successfulDestroy(property) {
    return i18n.tc('graphql.mutation.success.destroy', name, { name: property });
}
export function confirmation(property) {
    return i18n.tc('confirmation.remove', name, { name: property });
}
export function moduleFieldTitle(moduleName) {
    return i18n.tc('title.module_field', name, { name: moduleName });
}
export function invalidType(property) {
    return i18n.tc('validations.type', name, { name: property });
}
export function maxLength(property, length) {
    return i18n.tc('validations.max', name, length, {
        name: property,
        length,
    });
}
export function minLength(property, length) {
    return i18n.tc('validations.min', name, length, {
        name: property,
        length,
    });
}
export function maxFileSize(property, size) {
    return i18n.tc('validations.max_file_size', name, size, { name: property, size });
}
export function placeholder() {
    return i18n.tc('input.placeholder');
}
export function noteMessage() {
    return i18n.tc('note.message');
}
/* eslint-enable */
